const memberTransaction = intl => ({
  no: intl.formatMessage({ id: 'memberTransaction.no' }),
  type: intl.formatMessage({ id: 'memberTransaction.type' }),
  'source transaction no': intl.formatMessage({ id: 'memberTransaction.no' }),
  source_transaction_no: intl.formatMessage({ id: 'memberTransaction.no' }),
  'member identity type': '會員識別類型',
  member_identity_type: '會員識別類型',
  'member card no': intl.formatMessage({ id: 'member.card.no' }),
  member_card_no: intl.formatMessage({ id: 'member.card.no' }),
  mobile: intl.formatMessage({ id: 'member.mobile' }),
  'brand id': intl.formatMessage({ id: 'brand' }),
  brand_id: intl.formatMessage({ id: 'brand' }),
  'store code': intl.formatMessage({ id: 'store.code' }),
  store_code: intl.formatMessage({ id: 'store.code' }),
  'pos device no': intl.formatMessage({ id: 'posDeviceNo' }),
  pos_device_no: intl.formatMessage({ id: 'posDeviceNo' }),
  'receipt no': intl.formatMessage({ id: 'receipt.no' }),
  receipt_no: intl.formatMessage({ id: 'receipt.no' }),
  'receipt random no': intl.formatMessage({ id: 'receipt.randomNo' }),
  receipt_random_no: intl.formatMessage({ id: 'receipt.randomNo' }),
  'receipt payment amount': intl.formatMessage({ id: 'receipt.paymentAmount' }),
  receipt_payment_amount: intl.formatMessage({ id: 'receipt.paymentAmount' }),
  'membership level module adopted payment amount': intl.formatMessage({
    id: 'memberTransaction.levelModuleAdoptedPaymentAmount',
  }),
  membership_level_module_adopted_payment_amount: intl.formatMessage({
    id: 'memberTransaction.levelModuleAdoptedPaymentAmount',
  }),
  'member point module adopted payment amount': intl.formatMessage({
    id: 'memberTransaction.pointModuleAdoptedPaymentAmount',
  }),
  member_point_module_adopted_payment_amount: intl.formatMessage({
    id: 'memberTransaction.pointModuleAdoptedPaymentAmount',
  }),
  'transaction datetime': intl.formatMessage({ id: 'memberTransaction.transactionDateTime' }),
  transaction_datetime: intl.formatMessage({ id: 'memberTransaction.transactionDateTime' }),
  products: intl.formatMessage({ id: 'memberTransaction.products' }),
  'products.name': intl.formatMessage({ id: 'product.name' }),
  'products.code': intl.formatMessage({ id: 'product.code' }),
  'products.retail_price': intl.formatMessage({ id: 'product.retailPrice' }),
  'products.sale_price': intl.formatMessage({ id: 'product.salePrice' }),
  'products.number': intl.formatMessage({ id: 'product.number' }),
  meta: intl.formatMessage({ id: 'memberTransaction.meta' }),
  'meta.key': intl.formatMessage({ id: 'title' }),
  'meta.value': intl.formatMessage({ id: 'description' }),
  customized_member_point_allocations: intl.formatMessage({
    id: 'memberTransaction.customizedPointAllocation',
  }),
  'customized_member_point_allocations.member_point_type_id': intl.formatMessage({
    id: 'memberTransaction.customizedPointAllocation.pointType.name',
  }),
  'customized_member_point_allocations.quantity': intl.formatMessage({
    id: 'memberTransaction.customizedPointAllocation.quantity',
  }),
  'customized_member_point_allocations.expiration_datetime': intl.formatMessage({
    id: 'memberTransaction.customizedPointAllocation.expirationDateTime',
  }),
  note: intl.formatMessage({ id: 'memberTransaction.note' }),
  remark: intl.formatMessage({ id: 'memberTransaction.remark' }),
});

export default memberTransaction;
